module.exports = __webpack_public_path__ + "img/13.70369d21.jpg";